import { MembershipRoles } from '../data-models/membership-roles.model';
import { CreateDroneReportRequest } from '../request-models/create-drone-report-request.model';
import { DroneReportListOptions } from '../request-models/drone-report-list-options.model';
import { QueryParams } from '../../abstract/query-params';
import { omitUndefined } from './wire-value-utils';

/** Roles that can create, generate and delete drone reports. */
export const DRONE_REPORT_ROLES = [
  MembershipRoles.Owner,
  MembershipRoles.ChiefSupervisor,
  MembershipRoles.PilotInCharge,
];

/** The create body with only the fields that are set. */
export function toCreateDroneReportRequest(input: CreateDroneReportRequest): CreateDroneReportRequest {
  return omitUndefined<CreateDroneReportRequest>({
    name: input.name,
    startDate: input.startDate,
    endDate: input.endDate,
    droneId: input.droneId,
    droneSource: input.droneSource,
    scope: input.scope,
    sprayRecordId: input.sprayRecordId,
  });
}

/** List query params. The drone filter is only sent when both `droneId` and `droneSource` are set. */
export function toDroneReportListQuery(options: DroneReportListOptions = {}): QueryParams {
  const byDrone = !!options.droneId && !!options.droneSource;
  return {
    page: options.page,
    limit: options.limit,
    status: options.status,
    droneId: byDrone ? options.droneId : undefined,
    droneSource: byDrone ? options.droneSource : undefined,
  };
}
